import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { capatelize } from 'src/app/SEO_Constant/routes.constant';
import { description, keyword } from 'src/app/SEO_Constant/seo';

@Component({
    selector: 'app-video-creation',
    templateUrl: './video-creation.component.html',
    styleUrls: ['./video-creation.component.css'],
    standalone: false
})
export class VideoCreationComponent implements OnInit {
  titles:any;
  bannerArray:any = {
    "bannerTXT" : [
      {
        title: ' Video quality.',
      },
      {
        title: 'Video compression method.',
      },
      {
        title: 'Stereoscopic.',
      },
      {
        title: 'Aspect ratio',
      },
    ],
    "bannerImg" : {
      "banner": "assets/img/video.png",
      "backgroundImg": "assets/img/banner-background.jpg"
    }
  }

  constructor( private title : Title, private router:Router, private meta: Meta ) {
    this.titles = router.url.split('/')[router.url.split('/').length-1].replace(/-/g,' ')
   }

  ngOnInit(): void {
    this.title.setTitle(capatelize(this.titles) +' | Resiliencesoft')
         this.meta.removeTag('name=description');
            this.meta.removeTag('name=keywords');
            this.meta.addTags([
              {
                name: 'description',
                content: description.VideoCreation,
              },
              { name: 'keywords', content: capatelize(keyword.globle) + capatelize(keyword.VideoCreation) },
            ]);
  }

}
